var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-44"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.34,
    y: 102.67,
    width: 169.52,
    height: 189.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.67,
    y: 105.74,
    width: 166.19,
    height: 183.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.81 203.13 88.81 190.24 92.49 190.24 92.49 181.64 97.4 181.64 97.4 168.75 98.63 168.75 98.63 181.64 103.54 181.64 103.54 190.24 107.22 190.24 107.22 203.13 113.98 203.13 113.98 206.81 117.05 206.81 117.05 220.93 117.66 220.93 117.66 200.67 119.5 200.67 119.5 213.56 121.34 213.56 121.34 182.87 122.57 182.87 122.57 195.76 127.48 195.76 127.48 191.47 129.32 191.47 129.32 173.66 133.01 173.66 133.01 155.86 134.24 155.86 134.24 158.31 159.41 158.31 159.41 150.95 163.7 150.95 163.7 122.71 165.55 122.71 165.55 150.95 171.69 150.95 171.69 158.31 174.14 158.31 174.14 195.15 187.03 195.15 187.03 184.1 182.74 184.1 182.74 182.26 187.03 182.26 187.03 179.19 199.31 179.19 199.31 150.95 202.38 150.95 202.38 146.65 217.11 146.65 217.11 150.95 218.96 150.95 218.96 190.24 225.71 190.24 225.71 208.04 229.39 208.04 229.39 193.92 232.46 193.92 232.46 190.24 239.22 190.24 239.22 177.34 242.9 177.34 242.9 168.75 247.19 168.75 247.19 155.86 248.86 155.86 248.86 289.23 82.67 289.23 82.67 203.13 88.81 203.13",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.27,
    y: 160.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.27,
    y: 163.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.27,
    y: 174.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.27,
    y: 177.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.27,
    y: 180.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.27,
    y: 189.4,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.27,
    y: 192.31,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.03,
    y: 171.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.03,
    y: 174.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.03,
    y: 177.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.03,
    y: 180.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.03,
    y: 183.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.03,
    y: 189.4,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.03,
    y: 192.31,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.79,
    y: 160.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.79,
    y: 163.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.79,
    y: 166.07,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.79,
    y: 168.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.79,
    y: 171.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.79,
    y: 174.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.79,
    y: 177.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.79,
    y: 180.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.79,
    y: 183.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.79,
    y: 186.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.79,
    y: 192.31,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.56,
    y: 160.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.56,
    y: 163.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.56,
    y: 166.07,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.56,
    y: 168.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.56,
    y: 171.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.56,
    y: 174.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.56,
    y: 177.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.56,
    y: 203.98,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.32,
    y: 160.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.32,
    y: 163.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.32,
    y: 166.07,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.32,
    y: 168.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.32,
    y: 171.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.32,
    y: 174.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.32,
    y: 177.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.32,
    y: 180.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.32,
    y: 198.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.32,
    y: 201.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.32,
    y: 203.98,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.32,
    y: 206.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.32,
    y: 218.56,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 160.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 163.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 166.07,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 168.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 171.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 174.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 177.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 180.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 183.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 186.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 195.23,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 198.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 201.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 203.98,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 206.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.08,
    y: 218.56,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 160.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 163.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 166.07,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 168.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 171.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 174.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 177.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 180.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 183.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 186.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 189.4,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 192.31,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 195.23,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 198.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 201.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 203.98,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 206.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 209.81,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 160.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 163.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 166.07,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 168.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 171.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 174.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 177.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 180.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 183.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 186.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 195.23,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 198.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 201.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 203.98,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 160.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 163.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 166.07,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 168.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 171.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 174.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 177.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 180.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 183.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 186.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 195.23,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 198.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 201.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.47,
    y: 152.67,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.47,
    y: 155.58,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.47,
    y: 158.5,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.47,
    y: 161.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.47,
    y: 164.33,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.47,
    y: 167.25,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.47,
    y: 170.16,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.47,
    y: 173.08,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.47,
    y: 181.83,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.47,
    y: 184.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 152.67,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 155.58,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 158.5,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 161.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 164.33,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 167.25,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 170.16,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 173.08,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 184.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 152.67,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 155.58,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 158.5,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 161.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 164.33,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 167.25,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 170.16,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 173.08,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 152.67,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 155.58,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 158.5,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 161.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 164.33,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 167.25,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 173.08,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 176,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 184.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 187.66,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 190.58,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 193.49,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 196.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 199.32,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 202.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 152.67,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 155.58,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 158.5,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 161.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 164.33,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 167.25,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 176,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 178.91,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 181.83,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 184.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 187.66,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 190.58,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 193.49,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 196.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 199.32,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 202.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 205.16,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.52,
    y: 210.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 152.67,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 155.58,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 158.5,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 161.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 164.33,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 167.25,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 176,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 178.91,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 181.83,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 184.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 193.49,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 196.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 199.32,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 202.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 205.16,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 210.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.29,
    y: 213.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.35,
    y: 179.78,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.35,
    y: 182.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.35,
    y: 185.61,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.35,
    y: 188.53,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.35,
    y: 191.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.35,
    y: 194.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.35,
    y: 197.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.35,
    y: 206.03,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.35,
    y: 208.94,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.35,
    y: 211.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.12,
    y: 179.78,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.12,
    y: 182.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.12,
    y: 185.61,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.12,
    y: 188.53,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.12,
    y: 191.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.12,
    y: 194.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.12,
    y: 197.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.88,
    y: 179.78,
    width: 2.5,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.88,
    y: 182.7,
    width: 2.5,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.88,
    y: 185.61,
    width: 2.5,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.88,
    y: 188.53,
    width: 2.5,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.88,
    y: 191.45,
    width: 2.5,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.88,
    y: 194.36,
    width: 2.5,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.88,
    y: 197.28,
    width: 2.5,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 183.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 186.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 189.4,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 192.31,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 195.23,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 198.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 201.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 203.98,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 206.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 209.81,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 212.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 215.64,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 218.56,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 221.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 224.39,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 227.31,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 230.22,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 233.14,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 236.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.94,
    y: 238.97,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 183.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 186.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 189.4,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 192.31,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 195.23,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 198.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 201.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 203.98,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 206.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 209.81,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 212.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 215.64,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 218.56,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 221.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 224.39,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 227.31,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 230.22,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 233.14,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 183.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 186.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 189.4,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 192.31,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 195.23,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 198.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 201.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 203.98,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 206.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 209.81,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 212.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 215.64,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 218.56,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 221.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 224.39,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 227.31,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 230.22,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 233.14,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 204.85,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 207.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 210.68,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 213.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 216.51,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 219.43,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 222.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 225.26,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 228.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 231.09,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 234.01,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 236.93,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 239.84,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.36,
    y: 204.85,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.36,
    y: 207.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.36,
    y: 210.68,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.36,
    y: 213.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.36,
    y: 216.51,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.36,
    y: 219.43,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.36,
    y: 222.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.36,
    y: 225.26,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.36,
    y: 228.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.36,
    y: 231.09,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.36,
    y: 234.01,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.36,
    y: 236.93,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.36,
    y: 239.84,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 204.85,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 207.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 210.68,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 213.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 216.51,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 219.43,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 222.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 225.26,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 228.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 231.09,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 234.01,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 236.93,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 239.84,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 242.76,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.48,
    y: 205.72,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.48,
    y: 208.63,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.48,
    y: 211.55,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.48,
    y: 214.47,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.48,
    y: 217.38,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.48,
    y: 220.3,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.48,
    y: 223.22,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.48,
    y: 226.13,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.48,
    y: 229.05,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.48,
    y: 231.96,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.48,
    y: 240.71,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.24,
    y: 205.72,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.24,
    y: 208.63,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.24,
    y: 211.55,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.24,
    y: 214.47,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.24,
    y: 217.38,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.24,
    y: 220.3,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.24,
    y: 223.22,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.24,
    y: 226.13,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.24,
    y: 229.05,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.24,
    y: 237.8,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.24,
    y: 240.71,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 205.72,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 208.63,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 211.55,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 214.47,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 217.38,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 220.3,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 223.22,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 226.13,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 234.88,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 237.8,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 240.71,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 161.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 164.33,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 167.25,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 170.16,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 173.08,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 176,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 178.91,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 181.83,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 184.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 187.66,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 190.58,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 193.49,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 196.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 199.32,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 202.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 205.16,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 208.07,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 213.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 216.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 219.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 222.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 225.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 161.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 164.33,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 167.25,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 170.16,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 173.08,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 176,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 178.91,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 181.83,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 184.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 187.66,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 190.58,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 193.49,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 196.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 199.32,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 202.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 205.16,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 222.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 225.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 161.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 164.33,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 167.25,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 170.16,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 173.08,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 176,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 178.91,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 181.83,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 184.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 187.66,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 190.58,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 193.49,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 196.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 199.32,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 202.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 205.16,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 210.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 213.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 216.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 219.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 225.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 198.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 201.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 203.98,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 206.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 209.81,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 212.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 215.64,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 221.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 224.39,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 227.31,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 230.22,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 233.14,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 236.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 238.97,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.65,
    y: 241.89,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 198.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 201.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 203.98,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 206.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 209.81,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 212.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 221.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 224.39,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 227.31,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 230.22,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 233.14,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 236.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 238.97,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 241.89,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 198.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 201.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 203.98,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 206.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 209.81,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 212.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 218.56,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 221.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 224.39,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 227.31,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 230.22,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 233.14,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 236.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 238.97,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 241.89,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 181.83,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 184.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 187.66,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 190.58,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 193.49,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 196.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 199.32,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 202.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 205.16,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 208.07,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 210.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 213.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 216.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 222.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 225.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 228.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 231.4,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 237.23,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 240.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 243.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 181.83,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 184.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 187.66,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 190.58,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 193.49,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 196.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 199.32,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 202.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 205.16,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 208.07,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 210.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 213.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 216.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 225.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 228.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 234.32,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 237.23,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 240.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.16,
    y: 243.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 181.83,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 184.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 187.66,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 190.58,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 193.49,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 196.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 199.32,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 202.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 205.16,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 208.07,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 210.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 213.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 216.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 219.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 225.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 231.4,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 234.32,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 237.23,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 240.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 243.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.14,
    y: 198.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.14,
    y: 201.37,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.14,
    y: 204.29,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.14,
    y: 207.2,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.14,
    y: 210.12,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.14,
    y: 213.03,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.14,
    y: 221.78,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.14,
    y: 224.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.14,
    y: 227.61,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.14,
    y: 230.53,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.14,
    y: 233.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.14,
    y: 236.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.14,
    y: 239.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.91,
    y: 198.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.91,
    y: 201.37,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.91,
    y: 204.29,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.91,
    y: 207.2,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.91,
    y: 210.12,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.91,
    y: 213.03,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.91,
    y: 221.78,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.91,
    y: 224.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.91,
    y: 227.61,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.91,
    y: 230.53,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.91,
    y: 233.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.91,
    y: 236.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.91,
    y: 242.2,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.4,
    y: 103.1,
    width: 3.45,
    height: 189.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.48,
    y: 103.1,
    width: 2.92,
    height: 189.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.56,
    y: 103.1,
    width: 2.92,
    height: 189.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.9,
    cy: 96.43,
    r: 14.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.94,96.43a12,12,0,1,1-12-12A12,12,0,0,1,356.94,96.43Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "344.33 88.17 344.33 96.59 338.75 93.43",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.33,97.59a1,1,0,0,1-.49-.13l-5.58-3.16a1,1,0,0,1,1-1.74l4.09,2.32V88.17a1,1,0,0,1,2,0v8.42a1,1,0,0,1-.5.87A1,1,0,0,1,344.33,97.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.98,
    y: 119.3,
    width: 62.64,
    height: 82.68,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.29 128.1 374.29 164.45 388.77 163.63 390.43 128.1 374.29 128.1",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.01 135.13 408.29 135.13 408.1 166.95 396.56 167.13 386.01 135.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.32 130.44 370.18 130.44 368.13 158.83 360.8 160.65 364.32 130.44",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.36,
    y: 136.09,
    width: 62.44,
    height: 75.98,
    transform: "translate(625.16 348.16) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.65 193.25 328.46 161 292.96 155.14 295.65 193.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.67 185.6 329.29 160.87 304.59 166.94 302.79 185.86 327.67 185.6",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.35,
    cy: 150.8,
    r: 9.97,
    transform: "translate(-20.13 253.01) rotate(-45)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.44,194.42a4.84,4.84,0,1,1,4.84,4.84A4.84,4.84,0,0,1,324.44,194.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.13 202.92 314.16 194.42 325.9 184.75 328.13 202.92",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.89,
    y: 145.75,
    width: 2.75,
    height: 60.67,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.39,
    y: 145.75,
    width: 3.55,
    height: 57.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.63,
    y: 185.86,
    width: 18.15,
    height: 18.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.77,
    y: 313.38,
    width: 65.62,
    height: 59.63,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.17,
    y: 308.13,
    width: 8.25,
    height: 74.05,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.22,
    y: 318.94,
    width: 5.38,
    height: 21.39,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.51,
    y: 318.94,
    width: 5.38,
    height: 21.39,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.59,
    y: 320.8,
    width: 5.38,
    height: 19.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.13,
    y: 320.8,
    width: 5.38,
    height: 19.54,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.66,
    y: 318.94,
    width: 3.47,
    height: 21.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.97,
    y: 320.8,
    width: 2.69,
    height: 19.54,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.89,
    y: 318.94,
    width: 5.38,
    height: 21.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.27,
    y: 320.8,
    width: 5.38,
    height: 19.54,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.81,
    y: 320.8,
    width: 5.38,
    height: 19.54,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.33,
    y: 318.94,
    width: 3.47,
    height: 21.39,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.64,
    y: 320.8,
    width: 2.69,
    height: 19.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.18,
    y: 319.57,
    width: 2.69,
    height: 20.77,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.49,
    y: 349.32,
    width: 5.38,
    height: 20.39,
    transform: "translate(812.37 719.02) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.2,
    y: 349.32,
    width: 5.38,
    height: 20.39,
    transform: "translate(767.78 719.02) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.12,
    y: 351.17,
    width: 5.38,
    height: 18.54,
    transform: "translate(801.61 720.88) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.58,
    y: 351.17,
    width: 5.38,
    height: 18.54,
    transform: "translate(778.53 720.88) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.95,
    y: 349.32,
    width: 3.47,
    height: 20.39,
    transform: "translate(787.38 719.02) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.43,
    y: 351.17,
    width: 2.69,
    height: 18.54,
    transform: "translate(793.55 720.88) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.82,
    y: 349.32,
    width: 5.38,
    height: 20.39,
    transform: "translate(757.02 719.02) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.45,
    y: 351.17,
    width: 5.38,
    height: 18.54,
    transform: "translate(746.27 720.88) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.91,
    y: 351.17,
    width: 5.38,
    height: 18.54,
    transform: "translate(723.19 720.88) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.28,
    y: 349.32,
    width: 3.47,
    height: 20.39,
    transform: "translate(732.04 719.02) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.74,
    y: 349.32,
    width: 3.47,
    height: 20.39,
    transform: "translate(708.96 719.02) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.76,
    y: 351.17,
    width: 2.69,
    height: 18.54,
    transform: "translate(738.2 720.88) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.22,
    y: 349.94,
    width: 2.69,
    height: 19.77,
    transform: "translate(715.12 719.65) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.06,308.13H343.69v69.28h65.17v4.76h4.4v-74Zm-2.2,61.58h-61V344.76h61Zm0-29.35h-61V315.82h61Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.04,
    y: 313.38,
    width: 65.62,
    height: 59.63,
    transform: "translate(625.71 686.39) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.56,
    y: 376.54,
    width: 8.25,
    height: 5.63,
    transform: "translate(573.38 758.71) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.08,
    y: 318.94,
    width: 5.38,
    height: 21.39,
    transform: "translate(681.53 659.27) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.78,
    y: 318.94,
    width: 5.38,
    height: 21.39,
    transform: "translate(636.94 659.27) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.7,
    y: 320.8,
    width: 5.38,
    height: 19.54,
    transform: "translate(670.78 661.13) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.16,
    y: 320.8,
    width: 5.38,
    height: 19.54,
    transform: "translate(647.7 661.13) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.54,
    y: 318.94,
    width: 3.47,
    height: 21.39,
    transform: "translate(656.55 659.27) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.01,
    y: 320.8,
    width: 2.69,
    height: 19.54,
    transform: "translate(662.71 661.13) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.95,
    y: 318.94,
    width: 5.38,
    height: 21.39,
    transform: "translate(633.28 659.27) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.57,
    y: 320.8,
    width: 5.38,
    height: 19.54,
    transform: "translate(622.52 661.13) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.03,
    y: 320.8,
    width: 5.38,
    height: 19.54,
    transform: "translate(599.44 661.13) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.41,
    y: 318.94,
    width: 3.47,
    height: 21.39,
    transform: "translate(608.3 659.27) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.89,
    y: 320.8,
    width: 2.69,
    height: 19.54,
    transform: "translate(614.46 661.13) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.34,
    y: 319.57,
    width: 2.69,
    height: 20.77,
    transform: "translate(591.38 659.9) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.82,
    y: 349.32,
    width: 5.38,
    height: 20.39,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.11,
    y: 349.32,
    width: 5.38,
    height: 20.39,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.2,
    y: 351.17,
    width: 5.38,
    height: 18.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.74,
    y: 351.17,
    width: 5.38,
    height: 18.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.26,
    y: 349.32,
    width: 3.47,
    height: 20.39,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.57,
    y: 351.17,
    width: 2.69,
    height: 18.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.95,
    y: 349.32,
    width: 5.38,
    height: 20.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.32,
    y: 351.17,
    width: 5.38,
    height: 18.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.86,
    y: 351.17,
    width: 5.38,
    height: 18.54,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.39,
    y: 349.32,
    width: 3.47,
    height: 20.39,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.22,
    y: 349.32,
    width: 3.47,
    height: 20.39,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.7,
    y: 351.17,
    width: 2.69,
    height: 18.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.24,
    y: 349.94,
    width: 2.69,
    height: 19.77,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.17,308.13v74h4.4v-4.76h65.17V308.13H278.17Zm4.4,36.63h61v24.95h-61Zm0-28.94h61v24.54h-61Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-44"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-44",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.05,372.62s-7.76-9.22-12.72-4.92-2.45,13.43,3.27,13.73a14.38,14.38,0,0,0,9.45-2.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.05,372.62s-7.76-9.22-12.72-4.92-2.45,13.43,3.27,13.73a14.38,14.38,0,0,0,9.45-2.89Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.68,349.22s6.51-6.82,10.54-5.66,3.62,17.45-8.89,10.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.68,349.22s6.51-6.82,10.54-5.66,3.62,17.45-8.89,10.85Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.42,400.11s-21.4-29.27-4-35.2,20.47,23.55,15.51,31.76S390.42,400.11,390.42,400.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.34,340.18s13.28-30.82-6.38-31.75-21.81,30.56.82,35.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.42,400.11s-21.4-29.27-4-35.2,20.47,23.55,15.51,31.76S390.42,400.11,390.42,400.11Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.34,340.18s13.28-30.82-6.38-31.75-21.81,30.56.82,35.13Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.63,365.41s-6.45-27.21,6-29.38,24.65,22.42-1,34.78C400.57,370.81,396.17,368.08,395.63,365.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.63,365.41s-6.45-27.21,6-29.38,24.65,22.42-1,34.78C400.57,370.81,396.17,368.08,395.63,365.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.02 395.96 410.94 395.96 407.94 418.95 378.02 418.95 375.02 395.96",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.7,338c-7.4-5.41-12.53-15.87-8.16-24.68-.18.82-.4,1.71-.6,2.53-1.46,8.35,3.12,16.32,8.76,22.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,311.53c8.53,1.73,12.3,10.78,11.31,18.75-.19,1.13-.35,2.24-.58,3.35a55.41,55.41,0,0,0-.07-6.7c-.53-6.57-4.15-13-10.66-15.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,338c4.79,1.69,7.79,6.95,7.8,11.93,0,4.34-2.4,8.28-5.08,11.52a37.61,37.61,0,0,1-6.65,6.27,56.86,56.86,0,0,0,6-6.75c2.23-3,4.19-6.25,4.68-9.95.42-5.14-2.09-10.62-6.8-13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.34,340.18c1.28,4,2.42,8.75.34,12.67-1.74,2.54-1.92,5.86-2,8.89,0,1.06,0,2.11.07,3.17a24.11,24.11,0,0,1-.69-6.35,11.48,11.48,0,0,1,1.73-6.24c1.92-3.66,1-8.19.51-12.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.62,367.7c5,2.57,7,19.83,6.81,25.26-.15-1.1-.32-2.19-.53-3.28-.95-5.44-1.94-10.9-3.38-16.23-.67-2-1.1-4.46-2.9-5.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.54,368.65a24.07,24.07,0,0,0,4.88,22.91,25.73,25.73,0,0,1-2.25-2.18,19,19,0,0,1-2.63-20.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.73,352.54c2.28-.61,4.22-1.16,5.88-2.84-.41,2.55-3.65,3.75-5.88,2.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.4,348.05c1.07-2.18,4.73-3.54,6.28-1.17-2.19-.95-4.32.24-6.28,1.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.51,374c-2.5-1.76-5.09-4.76-8.32-3.19,2.63-3.12,7.05.37,8.32,3.19Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.51,378.54c-3.27,1.2-9.8,1.29-10.2-3.28,1.87,3.73,6.64,2.91,10.2,3.28Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trash-bin--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.65,399a2.4,2.4,0,0,0-1.92-3.45,5.13,5.13,0,0,0-1.63-5.61,1.16,1.16,0,0,0-.71-.32,1.35,1.35,0,0,0-.76.34l-4.49,3.23a2.71,2.71,0,0,0-.9.88c-.92,1.78,2.4,4.06,1,5.53-.39.43-1,.51-1.51.82-1.07.67-1.2,2.14-1.7,3.3s-2.24,2.05-2.91,1c.5-1.11-1-2.07-2.2-2.21s-2.47-.21-3.13-1.34c-1.72,1.5-5.55-2.68-5.47-4.36a3.29,3.29,0,0,0-2.67,2.74,20.29,20.29,0,0,0-.15,4.2c0,2.73-.92,5.4-.87,8.13,0,2.12.86,4.47,2.8,5.33a7.26,7.26,0,0,0,3,.4l22.13-.14a3.3,3.3,0,0,0,1.56-.26c1-.52,1.21-1.83,1.3-2.95q.58-7.21,1.19-14.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.65,399a2.4,2.4,0,0,0-1.92-3.45,5.13,5.13,0,0,0-1.63-5.61,1.16,1.16,0,0,0-.71-.32,1.35,1.35,0,0,0-.76.34l-4.49,3.23a2.71,2.71,0,0,0-.9.88c-.92,1.78,2.4,4.06,1,5.53-.39.43-1,.51-1.51.82-1.07.67-1.2,2.14-1.7,3.3s-2.24,2.05-2.91,1c.5-1.11-1-2.07-2.2-2.21s-2.47-.21-3.13-1.34c-1.72,1.5-5.55-2.68-5.47-4.36a3.29,3.29,0,0,0-2.67,2.74,20.29,20.29,0,0,0-.15,4.2c0,2.73-.92,5.4-.87,8.13,0,2.12.86,4.47,2.8,5.33a7.26,7.26,0,0,0,3,.4l22.13-.14a3.3,3.3,0,0,0,1.56-.26c1-.52,1.21-1.83,1.3-2.95q.58-7.21,1.19-14.42Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,375.56H282.61l.28,3.47.21,2.48.52,6.44.3,3.71.39,4.92.17,2.12.06.63.2,2.48.28,3.41.17,2.11.17,2.15.2,2.48.16,1.88.17,2.11.07.92h31.51l.07-.92.17-2.1.16-1.9.2-2.48.17-2.14.17-2.11.28-3.42.2-2.47.05-.63.17-2.12.4-4.92.3-3.7.52-6.45.2-2.48.28-3.47Zm2.06,2.28h0l-.66-.67h.72Zm-.17,2.1-.06.84-3.08,3.07-3.52-3.52,3.15-3.16h.74Zm-.89,11-2.25,2.25-3.52-3.53,3.52-3.51,2.44,2.43Zm-32.67-2.36h0l2.44-2.43,3.52,3.51-3.52,3.53-2.24-2.25ZM314.57,385,311,388.52,307.52,385l3.52-3.52ZM309,377.17h4l-2,2Zm.88,12.48-3.52,3.53-3.53-3.53,3.53-3.51Zm-11.71,4.67,3.53-3.52,3.51,3.52-3.51,3.52Zm2.38,4.66L297,402.51,293.53,399l3.52-3.53Zm5.81-3.52L309.9,399l-3.52,3.52L302.85,399Zm-4.66-6.94L298.19,385l3.53-3.52,3.51,3.52Zm-1.15,1.13-3.52,3.53-3.52-3.53,3.52-3.51Zm-8.19-1.13L288.86,385l3.52-3.52,3.53,3.52Zm0,2.28,3.53,3.52-3.53,3.52-3.52-3.52Zm3.53,12.85-3.53,3.52-3.52-3.52,3.52-3.52Zm1.13,1.14,3.53,3.52-3.52,3.53-3.52-3.53Zm1.15-1.14,3.53-3.52,3.51,3.52-3.51,3.52Zm8.19,1.14,3.52,3.52-3.52,3.53-3.53-3.53Zm4.66,4.66,3.53,3.53-2.29,2.28H309.8L307.52,413Zm-3.52-5.8,3.52-3.52,3.53,3.52L311,407.17Zm0-9.33L311,390.8l3.53,3.52L311,397.84Zm2.38-14-3.52,3.52-3.53-3.52,3.16-3.16h.74Zm-8.18-1.14-2-2h4Zm-1.15,1.14-3.52,3.52-3.52-3.52,3.15-3.16h.74Zm-6.17-3.16-2,2-2-2Zm-6.31,0,3.15,3.16-3.52,3.52-3.07-3.07-.06-.84,2.76-2.77Zm-3,0-.65.66h0l-.06-.66Zm-.22,6.1,1.73,1.72-1.47,1.47Zm1,11.81-.13-1.67h0l.9.91-.77.76Zm.17,2.13,1.74-1.75,3.52,3.53-3.52,3.52-1.42-1.42Zm.53,6.51v-.15l.08.08-.07.07Zm.61,7.51-.44-5.4,1-1,3.52,3.52-3.52,3.52-.6-.6Zm.32,4-.06-.81.34-.34,1.14,1.15Zm1.42-2.28,3.52-3.53,3.53,3.53-2.29,2.28h-2.48Zm7.05,2.28,1.14-1.15,1.15,1.15Zm4.56,0L298.19,413l3.53-3.53,3.51,3.53L303,415.26Zm4.76,0,1.15-1.15,1.14,1.15Zm10.75,0h-1.42l1.14-1.15.34.34Zm.33-4-.61.6-3.52-3.52,3.52-3.52,1,1Zm.62-7.67,0,.16-.07-.07.09-.09Zm.2-2.47-1.43,1.42L312.18,399l3.52-3.53,1.75,1.75Zm.49-6-.78-.77.91-.91Zm1-11.83-.26,3.21L316.84,385l1.74-1.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317,375.56H282.61l.28,3.47.21,2.48.52,6.44.3,3.71.39,4.92.17,2.12.06.63.2,2.48.28,3.41.17,2.11.17,2.15.2,2.48.16,1.88.17,2.11.07.92h31.51l.07-.92.17-2.1.16-1.9.2-2.48.17-2.14.17-2.11.28-3.42.2-2.47.05-.63.17-2.12.4-4.92.3-3.7.52-6.45.2-2.48.28-3.47Zm2.06,2.28h0l-.66-.67h.72Zm-.17,2.1-.06.84-3.08,3.07-3.52-3.52,3.15-3.16h.74Zm-.89,11-2.25,2.25-3.52-3.53,3.52-3.51,2.44,2.43Zm-32.67-2.36h0l2.44-2.43,3.52,3.51-3.52,3.53-2.24-2.25ZM314.57,385,311,388.52,307.52,385l3.52-3.52ZM309,377.17h4l-2,2Zm.88,12.48-3.52,3.53-3.53-3.53,3.53-3.51Zm-11.71,4.67,3.53-3.52,3.51,3.52-3.51,3.52Zm2.38,4.66L297,402.51,293.53,399l3.52-3.53Zm5.81-3.52L309.9,399l-3.52,3.52L302.85,399Zm-4.66-6.94L298.19,385l3.53-3.52,3.51,3.52Zm-1.15,1.13-3.52,3.53-3.52-3.53,3.52-3.51Zm-8.19-1.13L288.86,385l3.52-3.52,3.53,3.52Zm0,2.28,3.53,3.52-3.53,3.52-3.52-3.52Zm3.53,12.85-3.53,3.52-3.52-3.52,3.52-3.52Zm1.13,1.14,3.53,3.52-3.52,3.53-3.52-3.53Zm1.15-1.14,3.53-3.52,3.51,3.52-3.51,3.52Zm8.19,1.14,3.52,3.52-3.52,3.53-3.53-3.53Zm4.66,4.66,3.53,3.53-2.29,2.28H309.8L307.52,413Zm-3.52-5.8,3.52-3.52,3.53,3.52L311,407.17Zm0-9.33L311,390.8l3.53,3.52L311,397.84Zm2.38-14-3.52,3.52-3.53-3.52,3.16-3.16h.74Zm-8.18-1.14-2-2h4Zm-1.15,1.14-3.52,3.52-3.52-3.52,3.15-3.16h.74Zm-6.17-3.16-2,2-2-2Zm-6.31,0,3.15,3.16-3.52,3.52-3.07-3.07-.06-.84,2.76-2.77Zm-3,0-.65.66h0l-.06-.66Zm-.22,6.1,1.73,1.72-1.47,1.47Zm1,11.81-.13-1.67h0l.9.91-.77.76Zm.17,2.13,1.74-1.75,3.52,3.53-3.52,3.52-1.42-1.42Zm.53,6.51v-.15l.08.08-.07.07Zm.61,7.51-.44-5.4,1-1,3.52,3.52-3.52,3.52-.6-.6Zm.32,4-.06-.81.34-.34,1.14,1.15Zm1.42-2.28,3.52-3.53,3.53,3.53-2.29,2.28h-2.48Zm7.05,2.28,1.14-1.15,1.15,1.15Zm4.56,0L298.19,413l3.53-3.53,3.51,3.53L303,415.26Zm4.76,0,1.15-1.15,1.14,1.15Zm10.75,0h-1.42l1.14-1.15.34.34Zm.33-4-.61.6-3.52-3.52,3.52-3.52,1,1Zm.62-7.67,0,.16-.07-.07.09-.09Zm.2-2.47-1.43,1.42L312.18,399l3.52-3.53,1.75,1.75Zm.49-6-.78-.77.91-.91Zm1-11.83-.26,3.21L316.84,385l1.74-1.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 280.41,
    y: 374.12,
    width: 42.6,
    height: 4.49,
    rx: 1.64,
    transform: "translate(603.42 752.74) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.49,
    y: 414.46,
    width: 36.45,
    height: 4.49,
    rx: 1.64,
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-44"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.89,
    y: 148.62,
    width: 199.65,
    height: 135.93,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.89,
    y: 148.62,
    width: 199.65,
    height: 135.93,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.44,148.62S305,202.4,233.89,203.68V148.62Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.53,219.58s-39.45-4.11-78.48,18.56-78,44-121.16,34v12.4H433.53Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.97,
    y: 179.35,
    width: 95.47,
    height: 16.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.97,
    y: 202.54,
    width: 95.47,
    height: 16.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.52,189.12v.43H291.2v-4.69h3.22v.43H291.7V187h2.42v.42H291.7v1.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.18,187.52h1.76v.42h-1.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.81,187.5v2.05h-.47v-2c0-.74-.38-1.12-1-1.12a1.12,1.12,0,0,0-1.18,1.27v1.85h-.48v-2c0-.74-.37-1.12-1-1.12a1.13,1.13,0,0,0-1.17,1.27v1.85H298V186h.46v.65a1.41,1.41,0,0,1,1.29-.67,1.27,1.27,0,0,1,1.25.74,1.54,1.54,0,0,1,1.39-.74A1.32,1.32,0,0,1,303.81,187.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.76,187.36v2.19h-.46V189a1.32,1.32,0,0,1-1.21.58c-.8,0-1.28-.41-1.28-1s.34-1,1.35-1h1.12v-.22a.86.86,0,0,0-1-.93,1.79,1.79,0,0,0-1.18.42l-.21-.36a2.23,2.23,0,0,1,1.43-.47A1.25,1.25,0,0,1,307.76,187.36Zm-.48,1.13v-.58h-1.1c-.68,0-.91.27-.91.63s.33.67.89.67A1.12,1.12,0,0,0,307.28,188.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.94,184.91a.35.35,0,1,1,.35.34A.34.34,0,0,1,308.94,184.91Zm.11,1.11h.47v3.53h-.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.85,184.58h.47v5h-.47Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.87,209.67c0,1-.72,1.61-1.91,1.61H291.7v1.48h-.5v-4.69H293C294.15,208.07,294.87,208.67,294.87,209.67Zm-.49,0c0-.75-.5-1.17-1.44-1.17H291.7v2.34h1.24C293.88,210.84,294.38,210.41,294.38,209.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.46,210.57v2.19H298v-.55a1.33,1.33,0,0,1-1.21.58c-.8,0-1.29-.42-1.29-1s.35-1,1.36-1H298v-.22c0-.6-.34-.93-1-.93a1.76,1.76,0,0,0-1.17.42l-.22-.36a2.26,2.26,0,0,1,1.44-.47A1.24,1.24,0,0,1,298.46,210.57ZM298,211.7v-.58h-1.11c-.68,0-.9.27-.9.63s.33.66.89.66A1.13,1.13,0,0,0,298,211.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.26,212.35l.22-.37a2.11,2.11,0,0,0,1.25.39c.67,0,.94-.22.94-.57,0-.92-2.28-.2-2.28-1.59,0-.58.5-1,1.39-1a2.39,2.39,0,0,1,1.25.32l-.21.39a1.76,1.76,0,0,0-1-.31c-.63,0-.91.25-.91.59,0,1,2.28.23,2.28,1.58,0,.61-.54,1-1.45,1A2.35,2.35,0,0,1,299.26,212.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.54,212.35l.21-.37a2.14,2.14,0,0,0,1.25.39c.67,0,.95-.22.95-.57,0-.92-2.29-.2-2.29-1.59,0-.58.5-1,1.4-1a2.38,2.38,0,0,1,1.24.32l-.21.39a1.73,1.73,0,0,0-1-.31c-.64,0-.92.25-.92.59,0,1,2.28.23,2.28,1.58,0,.61-.53,1-1.45,1A2.32,2.32,0,0,1,302.54,212.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.4,209.23l-1.33,3.53h-.45l-1.11-2.89-1.11,2.89H307l-1.33-3.53h.46l1.1,3,1.13-3h.41l1.13,3,1.12-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.66,211a1.79,1.79,0,1,1,1.79,1.8A1.73,1.73,0,0,1,311.66,211Zm3.1,0a1.31,1.31,0,1,0-1.31,1.38A1.29,1.29,0,0,0,314.76,211Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,209.21v.46h-.11a1.14,1.14,0,0,0-1.19,1.3v1.8h-.47v-3.53h.45v.69A1.33,1.33,0,0,1,318,209.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,207.79v5h-.46v-.7a1.52,1.52,0,0,1-1.35.73,1.79,1.79,0,0,1,0-3.58,1.53,1.53,0,0,1,1.33.69v-2.11Zm-.47,3.2a1.31,1.31,0,1,0-1.3,1.38A1.29,1.29,0,0,0,321.55,211Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 286.97,
    y: 235.56,
    width: 95.47,
    height: 16.35,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.89,228.79l-.64-.89h-1v.88H297V226h1c.71,0,1.14.36,1.14,1a.87.87,0,0,1-.64.88l.68.95Zm0-1.83c0-.45-.3-.71-.86-.71h-.74v1.41H298C298.58,227.66,298.88,227.4,298.88,227Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M301.64,227.83h-1.76a.78.78,0,0,0,.83.73.85.85,0,0,0,.65-.27l.16.18a1.05,1.05,0,0,1-.82.34,1,1,0,0,1-1.1-1.07,1,1,0,0,1,1-1.06,1,1,0,0,1,1,1.06S301.64,227.8,301.64,227.83Zm-1.76-.21h1.5a.75.75,0,0,0-1.5,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M305.7,227.58v1.21h-.29V227.6c0-.44-.22-.67-.6-.67a.67.67,0,0,0-.7.76v1.1h-.29V227.6c0-.44-.22-.67-.6-.67a.68.68,0,0,0-.71.76v1.1h-.28v-2.1h.27v.39a.84.84,0,0,1,.77-.4.75.75,0,0,1,.75.44.91.91,0,0,1,.83-.44A.79.79,0,0,1,305.7,227.58Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M308.31,227.83h-1.76a.78.78,0,0,0,.83.73.82.82,0,0,0,.64-.27l.16.18a1.11,1.11,0,0,1-1.91-.73,1,1,0,1,1,2.05,0S308.31,227.8,308.31,227.83Zm-1.76-.21H308a.72.72,0,0,0-.74-.7A.74.74,0,0,0,306.55,227.62Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M312.37,227.58v1.21h-.29V227.6c0-.44-.22-.67-.6-.67a.67.67,0,0,0-.7.76v1.1h-.29V227.6c0-.44-.22-.67-.61-.67a.68.68,0,0,0-.7.76v1.1h-.28v-2.1h.27v.39a.84.84,0,0,1,.77-.4.75.75,0,0,1,.75.44.91.91,0,0,1,.83-.44A.79.79,0,0,1,312.37,227.58Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.27,227.74a1,1,0,0,1-1,1.07.92.92,0,0,1-.81-.43v.41h-.27v-3h.28v1.26a.93.93,0,0,1,.8-.41A1,1,0,0,1,315.27,227.74Zm-.28,0a.79.79,0,1,0-.79.82A.78.78,0,0,0,315,227.74Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M317.68,227.83h-1.76a.78.78,0,0,0,.83.73.86.86,0,0,0,.65-.27l.15.18a1,1,0,0,1-.81.34,1,1,0,0,1-1.1-1.07,1,1,0,0,1,1-1.06,1,1,0,0,1,1,1.06S317.68,227.8,317.68,227.83Zm-1.76-.21h1.49a.72.72,0,0,0-.74-.7A.74.74,0,0,0,315.92,227.62Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M319.33,226.68V227h-.07a.68.68,0,0,0-.71.77v1.07h-.28v-2.1h.27v.41A.79.79,0,0,1,319.33,226.68Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M324.39,227.58v1.21h-.28V227.6c0-.44-.23-.67-.61-.67a.67.67,0,0,0-.7.76v1.1h-.29V227.6c0-.44-.22-.67-.6-.67a.68.68,0,0,0-.71.76v1.1h-.28v-2.1h.27v.39a.84.84,0,0,1,.77-.4.75.75,0,0,1,.75.44.91.91,0,0,1,.83-.44A.79.79,0,0,1,324.39,227.58Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M327,227.83h-1.76a.78.78,0,0,0,.83.73.82.82,0,0,0,.64-.27l.16.18a1,1,0,0,1-.81.34,1,1,0,0,1-1.1-1.07,1,1,0,0,1,1-1.06,1,1,0,0,1,1,1.06S327,227.8,327,227.83Zm-1.76-.21h1.49a.72.72,0,0,0-.74-.7A.74.74,0,0,0,325.24,227.62Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 285.97,
    y: 234.56,
    width: 95.47,
    height: 16.35,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M316.47,261.3v1.09h1.45v.26h-1.45v1.19h-.3V261h1.92v.26Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M318.36,262.79a1.07,1.07,0,1,1,1.07,1.07A1,1,0,0,1,318.36,262.79Zm1.85,0a.78.78,0,1,0-1.56,0,.78.78,0,1,0,1.56,0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M322.14,261.72V262h-.07c-.44,0-.7.28-.7.78v1.07h-.29v-2.1h.27v.41A.8.8,0,0,1,322.14,261.72Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M324.58,261.74v1.84a.92.92,0,0,1-1.05,1.05,1.46,1.46,0,0,1-1-.32l.14-.22a1.27,1.27,0,0,0,.83.29c.53,0,.78-.24.78-.76v-.27a1,1,0,0,1-.82.41,1,1,0,0,1-1.06-1,1,1,0,0,1,1.06-1,.94.94,0,0,1,.83.42v-.4Zm-.27,1a.8.8,0,1,0-.8.78A.76.76,0,0,0,324.31,262.73Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M325.17,262.79a1.07,1.07,0,1,1,2.14,0,1.07,1.07,0,1,1-2.14,0Zm1.85,0a.79.79,0,1,0-1.57,0,.78.78,0,0,0,.79.82A.77.77,0,0,0,327,262.79Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M329,263.71a.67.67,0,0,1-.44.15.56.56,0,0,1-.62-.61V262h-.37v-.24h.37v-.46h.29v.46h.64V262h-.64v1.25a.33.33,0,0,0,.36.38.46.46,0,0,0,.31-.1Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M332.81,262c0,.59-.43,1-1.15,1h-.75v.88h-.29V261h1C332.38,261,332.81,261.4,332.81,262Zm-.3,0c0-.45-.29-.7-.85-.7h-.75v1.39h.75C332.22,262.69,332.51,262.44,332.51,262Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M335,262.54v1.3h-.27v-.33a.79.79,0,0,1-.73.35c-.47,0-.77-.25-.77-.61s.21-.6.82-.6h.66v-.13c0-.36-.2-.55-.59-.55a1.08,1.08,0,0,0-.7.24l-.13-.21a1.33,1.33,0,0,1,.86-.28A.75.75,0,0,1,335,262.54Zm-.29.67v-.35H334c-.4,0-.54.16-.54.38s.2.39.54.39A.66.66,0,0,0,334.67,263.21Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M335.44,263.6l.13-.23a1.19,1.19,0,0,0,.74.24c.4,0,.57-.14.57-.34,0-.55-1.37-.12-1.37-.95,0-.34.3-.6.84-.6a1.34,1.34,0,0,1,.74.2l-.13.22a1,1,0,0,0-.61-.18c-.38,0-.55.15-.55.35,0,.57,1.36.14,1.36.95,0,.36-.32.6-.87.6A1.39,1.39,0,0,1,335.44,263.6Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M337.39,263.6l.13-.23a1.22,1.22,0,0,0,.75.24c.4,0,.56-.14.56-.34,0-.55-1.36-.12-1.36-.95,0-.34.3-.6.83-.6a1.32,1.32,0,0,1,.74.2l-.12.22a1,1,0,0,0-.62-.18c-.38,0-.55.15-.55.35,0,.57,1.37.14,1.37.95,0,.36-.32.6-.87.6A1.42,1.42,0,0,1,337.39,263.6Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M342.69,261.74l-.8,2.1h-.27l-.66-1.72-.66,1.72H340l-.79-2.1h.27l.66,1.78.68-1.78h.24l.67,1.78.67-1.78Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M342.85,262.79a1.07,1.07,0,1,1,1.07,1.07A1,1,0,0,1,342.85,262.79Zm1.85,0a.79.79,0,1,0-1.57,0,.78.78,0,0,0,.79.82A.77.77,0,0,0,344.7,262.79Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M346.62,261.72V262h-.06a.68.68,0,0,0-.71.78v1.07h-.28v-2.1h.27v.41A.79.79,0,0,1,346.62,261.72Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M349,260.87v3h-.27v-.42a.92.92,0,0,1-.82.44,1.07,1.07,0,0,1,0-2.14.91.91,0,0,1,.8.41v-1.26Zm-.28,1.92a.79.79,0,1,0-1.57,0,.79.79,0,1,0,1.57,0Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M351.1,261.75c0-.28-.23-.48-.64-.48a.92.92,0,0,0-.76.32l-.21-.16a1.21,1.21,0,0,1,1-.41c.56,0,.92.26.92.69,0,.68-.73.72-.73,1.29h-.3C350.37,262.34,351.1,262.28,351.1,261.75Zm-.79,1.9a.2.2,0,0,1,.21-.2.2.2,0,0,1,.21.2.21.21,0,0,1-.21.21A.22.22,0,0,1,350.31,263.65Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 286.7,
    y: 224.4,
    width: 4.85,
    height: 4.85,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.17,239.68h.8v4.9h3v.69h-3.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.36,243.15a2.21,2.21,0,1,1,2.21,2.17A2.11,2.11,0,0,1,327.36,243.15Zm3.63,0a1.43,1.43,0,1,0-1.42,1.5A1.39,1.39,0,0,0,331,243.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.89,241v3.67a1.92,1.92,0,0,1-2.2,2.17,3.14,3.14,0,0,1-2-.63l.37-.59a2.62,2.62,0,0,0,1.63.55c1,0,1.46-.46,1.46-1.42v-.34a2,2,0,0,1-1.53.66,2.06,2.06,0,1,1,0-4.11,2,2,0,0,1,1.57.7V241Zm-.75,2a1.46,1.46,0,1,0-1.46,1.38A1.35,1.35,0,0,0,336.14,243Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.22,239.72a.52.52,0,1,1,.52.5A.5.5,0,0,1,338.22,239.72Zm.13,1.31h.77v4.24h-.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61,242.83v2.44h-.77v-2.35c0-.83-.42-1.24-1.14-1.24a1.26,1.26,0,0,0-1.35,1.41v2.18h-.76V241h.73v.64a1.83,1.83,0,0,1,1.53-.68A1.65,1.65,0,0,1,344.61,242.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.69 228.16 287.62 227 287.98 226.66 288.69 227.43 290.29 225.78 290.65 226.12 288.69 228.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.38,213.74h0a5.4,5.4,0,0,1-4.37-2.58l-.1-.14.1-.14a5,5,0,0,1,8.75,0l.1.14-.1.14A5.41,5.41,0,0,1,372.38,213.74ZM368.52,211a4.47,4.47,0,0,0,7.73,0,4.47,4.47,0,0,0-7.73,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.38,212.87a1.86,1.86,0,1,1,1.86-1.85A1.85,1.85,0,0,1,372.38,212.87Zm0-3.21a1.36,1.36,0,1,0,1.36,1.36A1.36,1.36,0,0,0,372.38,209.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.21,
    y: 210.77,
    width: 8.34,
    height: 0.5,
    transform: "translate(-40.14 325.12) rotate(-45)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M322.05,171.92l.21-.4a2.37,2.37,0,0,0,1.62.6c.91,0,1.31-.39,1.31-.87,0-1.34-3-.52-3-2.33,0-.72.56-1.35,1.81-1.35a2.72,2.72,0,0,1,1.52.44l-.17.41A2.6,2.6,0,0,0,324,168c-.9,0-1.3.39-1.3.88,0,1.35,3,.54,3,2.32,0,.72-.57,1.34-1.82,1.34A2.68,2.68,0,0,1,322.05,171.92Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M326.61,167.67a.36.36,0,0,1,.37-.35.36.36,0,1,1,0,.71A.36.36,0,0,1,326.61,167.67Zm.11,1.16h.5v3.69h-.5Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M332,168.83v3.24a1.62,1.62,0,0,1-1.84,1.84,2.58,2.58,0,0,1-1.72-.56l.25-.38a2.21,2.21,0,0,0,1.45.5c.93,0,1.36-.43,1.36-1.34v-.47a1.66,1.66,0,0,1-1.44.72,1.79,1.79,0,1,1,0-3.57,1.67,1.67,0,0,1,1.46.73v-.71Zm-.49,1.76a1.4,1.4,0,1,0-1.4,1.35A1.32,1.32,0,0,0,331.53,170.59Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M336.8,170.38v2.14h-.5v-2.09a1,1,0,0,0-1.11-1.18,1.21,1.21,0,0,0-1.28,1.34v1.93h-.5v-3.69h.47v.68a1.58,1.58,0,0,1,1.41-.7A1.41,1.41,0,0,1,336.8,170.38Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M339.87,167.67a.37.37,0,0,1,.73,0,.36.36,0,0,1-.37.37A.36.36,0,0,1,339.87,167.67Zm.11,1.16h.5v3.69H340Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M345.25,170.38v2.14h-.49v-2.09a1,1,0,0,0-1.11-1.18,1.22,1.22,0,0,0-1.29,1.34v1.93h-.5v-3.69h.48v.68a1.56,1.56,0,0,1,1.4-.7A1.4,1.4,0,0,1,345.25,170.38Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.28,148.26H152.55a8.85,8.85,0,0,0-8.85,8.85v25a8.85,8.85,0,0,0,8.85,8.85h8.38l-7,13.89,13-13.89h14.39a8.84,8.84,0,0,0,8.84-8.85v-25A8.84,8.84,0,0,0,181.28,148.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.28,148.26H152.55a8.85,8.85,0,0,0-8.85,8.85v25a8.85,8.85,0,0,0,8.85,8.85h8.38l-7,13.89,13-13.89h14.39a8.84,8.84,0,0,0,8.84-8.85v-25A8.84,8.84,0,0,0,181.28,148.26Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.42,175.87a1.31,1.31,0,0,1-1-.46l-5.6-6.59a1.31,1.31,0,1,1,2-1.7l4.6,5.42,7.58-8.95a1.31,1.31,0,1,1,2,1.7l-8.59,10.12A1.29,1.29,0,0,1,165.42,175.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.91,
    cy: 169.5,
    r: 14.26,
    transform: "translate(-70.97 167.67) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205,417.12h58.2a1.15,1.15,0,0,0,1.15-1.15v-3.71a1.15,1.15,0,0,0-1.15-1.14H208V292.3h54.26a2.09,2.09,0,0,0,2.09-2.08V286.3H205a3,3,0,0,0-3,3V414.12A3,3,0,0,0,205,417.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202,289.3V414.11a3,3,0,0,0,3,3h58.2a1.14,1.14,0,0,0,1.14-1.14v-3.71a1.15,1.15,0,0,0-1.14-1.15H208V292.3h54.26a2.09,2.09,0,0,0,2.08-2.09V286.3H205A3,3,0,0,0,202,289.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202,289.3v31.83q3,.76,6,1.47V292.3h54.26a2.09,2.09,0,0,0,2.08-2.09V286.3H205A3,3,0,0,0,202,289.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.75,400.37l23.86-2.08V367H129v31.33L153,400.37a4.12,4.12,0,0,1,3.72,4.1v3.18H93v-3.18A4.12,4.12,0,0,1,96.75,400.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.75,400.37l23.86-2.08V367H129v31.33L153,400.37a4.12,4.12,0,0,1,3.72,4.1v3.18H93v-3.18A4.12,4.12,0,0,1,96.75,400.37Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.94,411.6a5.49,5.49,0,1,0,5.49-5.49A5.48,5.48,0,0,0,148.94,411.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.75,411.6a5.49,5.49,0,1,1-5.48-5.49A5.48,5.48,0,0,1,100.75,411.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.88,342.66h3.85a3.71,3.71,0,0,1,3.71,3.71v27a0,0,0,0,1,0,0H119.17a0,0,0,0,1,0,0v-27A3.71,3.71,0,0,1,122.88,342.66Z",
    transform: "translate(249.61 716.01) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.88,342.66h3.85a3.71,3.71,0,0,1,3.71,3.71v27a0,0,0,0,1,0,0H119.17a0,0,0,0,1,0,0v-27A3.71,3.71,0,0,1,122.88,342.66Z",
    transform: "translate(249.61 716.01) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.06,280.66s2.58,51.83,13.74,60.75H101.86s-10.64-17.66-11.43-60.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.06,280.66s2.58,51.83,13.74,60.75H101.86s-10.64-17.66-11.43-60.75Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.09,337.11H152a4.49,4.49,0,0,1,4.49,4.49v4.1a0,0,0,0,1,0,0H94.59a0,0,0,0,1,0,0v-4.1A4.49,4.49,0,0,1,99.09,337.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.24,
    y: 341.41,
    width: 66.62,
    height: 4.29,
    rx: 1.81,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.24,
    y: 341.41,
    width: 66.62,
    height: 4.29,
    rx: 1.81,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.33,292h19.13c5.6,0,9.64-5,9-11.25l-.81-8.28c-.62-6.21-5.65-11.25-11.25-11.25H85.3c-5.6,0-9.64,5-9,11.25l.81,8.28C77.69,287,82.73,292,88.33,292Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.46,247.29c1.19,3.77,2.59,7.7,4.13,11.3,1.3,3,3.15,6.82,5.26,8.83,1.92,1.71,6.49,2.36,9.46,2.75,4,.51,8.26.7,12.41.87l.74,5.6A64.85,64.85,0,0,1,170,278.77c-5.08.18-11,0-15.4-3.12-6.39-5-9.17-11.66-12-18.69-.8-2.23-1.52-4.27-2.13-6.61l11-3.06Z",
    style: {
      fill: "#b65b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.55,242c3.15,1.08,6,5.61,13.93,23.78,0,0,1.29,2.22,7.72,3.61l-.59,10.2s-9.18-.4-11.31-1.87-14.9-22.48-14.9-22.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.2,269.41l-.59,10.2s-7.36-.32-10.43-1.45a4,4,0,0,1-.88-.42c-1.23-.86-6-8.25-9.85-14.33-2.79-4.42-5-8.15-5-8.15L146.55,242c3.15,1.08,6,5.61,13.94,23.77C160.49,265.79,161.77,268,168.2,269.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.18,278.16a4,4,0,0,1-.88-.42c-1.23-.86-6-8.25-9.85-14.33A101.11,101.11,0,0,1,150,253.25S157.32,267.92,157.18,278.16Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.54,271.55l7.17-2.58-.88,9.6s-6.58.84-7.39-2.62Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.65 270.91 192.55 278.82 186.83 278.57 187.71 268.97 193.65 270.91",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.25 268.97 171.91 270.07 170.57 279.99 166.91 280.62 168.25 268.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.74,305.09s48.39,19.09,59.64,27.07S251,393.94,251,393.94l-11.73,9s-33.84-49.14-38-52.47-58-19.86-58-19.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,393.94l-11.73,9s-7.9-11.47-16.53-23.7c-9.23-13.09-19.3-27-21.44-28.77-3-2.44-32.65-11.94-48.36-16.86-5.78-1.82-9.67-3-9.67-3l8.46-25.55s48.38,19.09,59.64,27.07S251,393.94,251,393.94Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.15 413.19 258.8 407.51 249.56 393.22 243.92 398.9 253.15 413.19",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.92 398.9 249.56 393.23 254.84 401.4 249 406.78 243.92 398.9",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.78,406.89s0,0,.07,0,0,0,0,0a9.88,9.88,0,0,0,1.9-.94,2.13,2.13,0,0,0,1-1.16,1,1,0,0,0-.39-1,.7.7,0,0,0-.65-.2c-.55.13-1.09.91-1.5,1.66a3,3,0,0,0-.46-2,.7.7,0,0,0-.87-.1.88.88,0,0,0-.49.63c-.23,1.08,1.22,2.82,1.29,2.92l.1-.1h0l-.09.11s-.07.11-.07.12A.13.13,0,0,0,259.78,406.89Zm.05-.74c0,.06-.05.12-.07.17-.44-.62-1.09-1.71-.95-2.35a.54.54,0,0,1,.24-.37l.07,0c.24-.12.37-.05.45,0A3.76,3.76,0,0,1,259.83,406.15Zm.34.24c.44-1,1.17-2.3,1.72-2.42a.32.32,0,0,1,.32.1.68.68,0,0,1,.26.62C262.36,405.21,261.51,405.83,260.17,406.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.69,406.38l-7.46,5a.56.56,0,0,0-.19.78h0l3.6,6.15a1.41,1.41,0,0,0,1.95.4c2.57-1.79,3.71-2.77,7-5a75.85,75.85,0,0,0,8.57-6.13c2.46-2.29.13-4.66-1.11-3.91-3,1.77-8.08,2.53-10.94,2.32A2.17,2.17,0,0,0,258.69,406.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.82 406.91 254.47 397.16 251.09 390.27 235.22 401.28 239.82 406.91",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.82 406.91 254.47 397.16 251.09 390.27 235.22 401.28 239.82 406.91",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.76,379.28c-9.23-13.09-19.3-27-21.44-28.77-3-2.44-32.65-11.94-48.36-16.86l-1.83-19,5.74-1,.65,1.46s35.86,8.13,46,13.21C210.05,331.53,218.82,363.61,222.76,379.28Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.61,408.79l0,0a.09.09,0,0,0,.07,0,10,10,0,0,0,2.11-.25,2.13,2.13,0,0,0,1.35-.76,1,1,0,0,0,0-1.06.71.71,0,0,0-.55-.41c-.56-.07-1.33.5-2,1.07a2.9,2.9,0,0,0,.21-2,.7.7,0,0,0-.78-.39,1,1,0,0,0-.68.43c-.57.95.22,3.07.26,3.19l.12-.07h0l-.12.08s-.11.08-.1.09Zm.3-.69-.13.14a4.07,4.07,0,0,1-.12-2.54.55.55,0,0,1,.35-.26l.09,0c.26,0,.36.08.4.18A3.73,3.73,0,0,1,220.91,408.1Zm.23.34c.75-.8,1.87-1.78,2.43-1.71a.33.33,0,0,1,.27.2.7.7,0,0,1,0,.67C223.6,408.05,222.6,408.36,221.14,408.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.27 412.53 219.48 409.04 215.19 391.86 207.99 395.35 212.27 412.53",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.99 395.35 215.19 391.87 217.64 401.69 210.34 404.82 207.99 395.35",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.75,407.94l-8.7,2.25a.56.56,0,0,0-.44.67h0l1.36,7a1.42,1.42,0,0,0,1.71,1c3-.84,4.42-1.39,8.24-2.41A74.22,74.22,0,0,0,232,413.54c3.08-1.34,1.67-4.35.25-4.05-3.38.69-8.47-.3-11.09-1.45A2.26,2.26,0,0,0,219.75,407.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.7,395.12S206.5,333.91,204,330.27c-4.06-6-52.88-15.67-52.88-15.67l5.73-1L150.23,296l-43.47,1.71s.91,28.72,5.33,36.42,69.81,11.24,74.06,13,17.22,49.77,17.22,49.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.7,395.12S206.5,333.91,204,330.27c-4.06-6-52.88-15.67-52.88-15.67l5.73-1L150.23,296l-43.47,1.71s.91,28.72,5.33,36.42,69.81,11.24,74.06,13,17.22,49.77,17.22,49.77Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.63 402.32 220.69 397.98 219.78 390.36 201.16 395.49 203.63 402.32",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.63 402.32 220.69 397.98 219.78 390.36 201.16 395.49 203.63 402.32",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.52 298.38 107.92 298.17 107.65 301.98 121.06 302.3 120.52 298.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.46 298.31 123.01 302.27 151.13 301.87 150.22 298.26 122.46 298.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,299l.36,2.61a1.35,1.35,0,0,0,1.35,1.13l4.5-.14a1,1,0,0,0,1-1.19l-.37-2.62a1.34,1.34,0,0,0-1.35-1.12l-4.49.14A1,1,0,0,0,136,299Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.86,297.61h41.3a2,2,0,0,0,2-1.78c5.1-40-4.64-53.81-4.64-53.81a75.23,75.23,0,0,0-11.32-2.31,147.3,147.3,0,0,0-16.81-.36A79.59,79.59,0,0,0,107,240.48c-2,.87-4.07,9.78-2,37.54.54,7.27.62,13.55.57,17.23A2.33,2.33,0,0,0,107.86,297.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.76 256.17 148.72 256.17 149.32 265.67 145.05 268.44 140.76 266.32 140.76 256.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,295.83a2,2,0,0,1-2,1.78h-41.3a2.33,2.33,0,0,1-2.34-2.36c0-3.68,0-10-.56-17.23q-.43-6-.63-10.84a145.73,145.73,0,0,1,.1-17.72c.5-6,1.53-8.53,2.57-9a79.73,79.73,0,0,1,11.43-1.13,147.17,147.17,0,0,1,16.8.36A75.23,75.23,0,0,1,146.55,242S156.29,255.87,151.19,295.83Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.8,238.94l13.34,4.55.54-3.82c-1.3-2.28-1.63-3.72-.53-6.37l-8.9-10.23C123.48,228.31,122.53,235.47,118.8,238.94Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24,245.47l2.62,1.09,2.28,1.43s3.05,17.46,2.2,32.2l2.56,2.1,2.7-2.17s-3.36-27.07-4.57-32.34l.53-1.27,1.23-2.62-2.27-1.19-3.61.79h-2.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87,227.24l5.27,6.06a18.21,18.21,0,0,0-.95,2.87c-2.23-.67-5-3.64-4.87-6.06A8.08,8.08,0,0,1,126.87,227.24Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.63,236.52a63.2,63.2,0,0,0,12,6.25,11.82,11.82,0,0,0,0-5.67l5.89,2.94s.49,4.57-.86,7l-4.33-3.17-4.86,4s-9.2-3.55-10.64-8.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.64,272,136,283c-19.58,4.36-28.19-7.85-31.65-15.85a145.73,145.73,0,0,1,.1-17.72c4.7-.22,10.55-.22,12.13,1,2.75,2.11,12.33,16.9,13.76,18S149.64,272,149.64,272Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.4,271.48l7.17-2.59-.88,9.6s-6.58.84-7.39-2.62Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.5 270.83 169.41 278.74 163.69 278.49 164.57 268.89 170.5 270.83",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,252.11a131.5,131.5,0,0,0,7,12.17,28.53,28.53,0,0,0,5.82,6.83,1.77,1.77,0,0,0,.59.34,27.35,27.35,0,0,0,7.68.9c7.26.07,14.65-.6,21.94-1.22l1.19,5.52A121.18,121.18,0,0,1,145,280.48c-5.47,1-10.46,1.75-16.28,1.19a14.82,14.82,0,0,1-5.37-1.63c-6.48-3.79-10.45-9.92-14.21-16-1.35-2.36-2.58-4.56-3.72-7.08l10.3-4.87Z",
    style: {
      fill: "#b65b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,240.48c-12.9,4.65,3.83,36.79,10.87,40.39S136.79,283,136.79,283l.84-11.17s-6.16-.75-8-1.19c-2.93-.7-8.85-13.64-12.84-20.67A22.48,22.48,0,0,0,107,240.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,240.48c-12.9,4.65,3.83,36.79,10.87,40.39S136.79,283,136.79,283l.84-11.17s-6.16-.75-8-1.19c-2.93-.7-8.85-13.64-12.84-20.67A22.48,22.48,0,0,0,107,240.48Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.97 270.99 134.93 283.96 138.63 283.27 139.6 271.68 135.97 270.99",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.18,212.53c.51,3-.78,8.82-4.53,6.36S145.29,207.39,146.18,212.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,213.6c-1.44,7.32-2.66,11.53,0,16.15,4,6.94,13.83,5.88,17.44-.87,3.25-6.09,5.06-17-1.27-21.67A10.29,10.29,0,0,0,125,213.6Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.48,205.53l8.29-.38.22,4.76-.49-.27s-.52,7-4.49,9.33C119.64,214.87,118.06,208.16,121.48,205.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62,218.88a7,7,0,0,0,2.35,4.85c1.87,1.63,3.89.22,4.28-2.1.35-2.09-.2-5.46-2.51-6.2A3.23,3.23,0,0,0,120.62,218.88Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.42,218.37c-.16.59,0,1.14.42,1.24s.82-.3,1-.89,0-1.14-.42-1.23S135.57,217.79,135.42,218.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.07,220.05c-.15.58,0,1.14.42,1.23s.83-.3,1-.88,0-1.14-.42-1.24S142.23,219.46,142.07,220.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.88,219.81a20.68,20.68,0,0,0,1.6,5.55,3.61,3.61,0,0,1-2.93-.23Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.81,226.58a5.07,5.07,0,0,0,.75.25.19.19,0,0,0,.22-.13.18.18,0,0,0-.13-.22,4.72,4.72,0,0,1-3.32-2.77.19.19,0,0,0-.23-.11.17.17,0,0,0-.11.23A4.9,4.9,0,0,0,134.81,226.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.93,215.72a.35.35,0,0,0,.35-.06,2.89,2.89,0,0,1,2.52-.59.35.35,0,0,0,.45-.23.34.34,0,0,0-.22-.44,3.54,3.54,0,0,0-3.19.71.35.35,0,0,0-.06.5A.42.42,0,0,0,133.93,215.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.54,218.49a.37.37,0,0,0,.49-.41,3.55,3.55,0,0,0-2-2.56.37.37,0,0,0-.47.2.36.36,0,0,0,.2.46,2.74,2.74,0,0,1,1.54,2A.38.38,0,0,0,145.54,218.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.94,211.42a3.56,3.56,0,0,0,.51.36,3.35,3.35,0,0,0,3.2.13c2.06-1,2.71-6.88,8.57-3.89a3.43,3.43,0,0,1,3.52,1.24c1.51,1.85.47,8.6,3.69,7.67s2.66-1.93,2.66-1.93-.9.57-1.43.12a3,3,0,0,0,.87-3.37s-.78.93-1.3.75a13.65,13.65,0,0,0-.89-8.11c-1.87-4.66-13.31-3.62-13.31-3.62s-1.44-2.41-6.61-.73-7.53,7.91-6.71,10.62",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "195.2 277.74 194.46 274.95 164.13 274.95 150.17 276.34 149.64 277.74 195.2 277.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.2 277.74 194.46 274.95 164.13 274.95 150.17 276.34 149.64 277.74 195.2 277.74",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.13 274.95 164.13 277.74 195.2 277.74 194.46 274.95 164.13 274.95",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.39,261.59a2.39,2.39,0,0,0,2.41,2.67h46.46a3,3,0,0,0,2.91-2.67l2.76-29.74a2.69,2.69,0,0,0-.06-.86,2.37,2.37,0,0,0-2.35-1.81H180.06a3,3,0,0,0-2.91,2.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.39,261.59a2.39,2.39,0,0,0,2.41,2.67h46.46a3,3,0,0,0,2.91-2.67l2.76-29.74a2.69,2.69,0,0,0-.06-.86,2.37,2.37,0,0,0-2.35-1.81H180.06a3,3,0,0,0-2.91,2.67Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,264.26h46.29a3,3,0,0,0,2.91-2.67l2.76-29.74a2.69,2.69,0,0,0-.06-.86h-46.3a3,3,0,0,0-2.9,2.67l-2.76,29.74A2.43,2.43,0,0,0,177,264.26Z",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.88 246.02 199.27 246.02 201.83 273.54 186.64 275.82 186.64 277.74 218.65 277.74 218.65 275.82 212.09 273.54 208.88 246.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.88 246.02 199.27 246.02 201.83 273.54 186.64 275.82 186.64 277.74 218.65 277.74 218.65 275.82 212.09 273.54 208.88 246.02",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.27 246.02 206.39 277.3 212.09 277.13 208.88 246.02 199.27 246.02",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.94,417.12h58.2a1.14,1.14,0,0,0,1.14-1.15v-3.71a1.14,1.14,0,0,0-1.14-1.14h-55.2V292.3H177.2a2.08,2.08,0,0,0,2.08-2.08V286.3H119.94a3,3,0,0,0-3,3V414.12A3,3,0,0,0,119.94,417.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.94,417.12h58.2a1.14,1.14,0,0,0,1.14-1.15v-3.71a1.14,1.14,0,0,0-1.14-1.14h-55.2V292.3H177.2a2.08,2.08,0,0,0,2.08-2.08V286.3H119.94a3,3,0,0,0-3,3V414.12A3,3,0,0,0,119.94,417.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.49,280.62H265.91a1.94,1.94,0,0,1,1.94,1.94v4.72a0,0,0,0,1,0,0H110.55a0,0,0,0,1,0,0v-4.73A1.94,1.94,0,0,1,112.49,280.62Z",
    transform: "translate(378.39 567.92) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.55,
    y: 280.62,
    width: 157.3,
    height: 3.33,
    transform: "translate(378.39 564.58) rotate(180)",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.25,281.49h163.9a1.88,1.88,0,0,0,1.88-1.87h0a1.88,1.88,0,0,0-1.88-1.88H107.25a1.88,1.88,0,0,0-1.88,1.88h0A1.88,1.88,0,0,0,107.25,281.49Z",
    style: {
      fill: "#407BFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.a80b17d16c3b632d15d1e752938f15ec.svg";
export { ForwardRef as ReactComponent };